import { FormEvent, ReactNode } from 'react'
import { FieldValues, FormProvider, UseFormReturn } from 'react-hook-form'
import styled from 'styled-components'

// Note: a fixed width sizes the popup (a percentage width would let wrapping content, like the icon
// picker, size it as one long line); min-width fills the popup when its footer is wider than the form
const Container = styled.div<{ $width: string }>(({ $width }) => ({
  minWidth: '100%',
  width: $width,
}))

const StyledForm = styled.form(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
}))

// Note: Enter in a field would otherwise submit past a disabled Save button
const preventSubmit = (event: FormEvent) => event.preventDefault()

interface PersonFormLayoutProps<T extends FieldValues> {
  children: ReactNode
  form: UseFormReturn<T>
  onSubmit: () => void
  submitDisabled?: boolean
  width?: string
}

export const PersonFormLayout = <T extends FieldValues>({
  children,
  form,
  onSubmit,
  submitDisabled = false,
  width = '52rem',
}: PersonFormLayoutProps<T>) => (
  <Container $width={width}>
    <FormProvider {...form}>
      <StyledForm onSubmit={submitDisabled ? preventSubmit : onSubmit}>{children}</StyledForm>
    </FormProvider>
  </Container>
)
